export default __webpack_public_path__ + "static/media/NewGroupByIcon.c648500c.svg";